import { ReactNode, memo } from 'react';
import { useBreakpoints } from '@shopify/polaris';
import { StyledScrollableWrapper } from './styled';

export interface IScrollableTableWrapperProps {
  children: ReactNode;
  enabled?: boolean;
}

const ScrollableTableWrapper = ({ children, enabled }: IScrollableTableWrapperProps) => {
  const { smDown } = useBreakpoints();
  const shouldWrap = enabled === undefined ? smDown : enabled;

  if (!shouldWrap) {
    return <>{children}</>;
  }

  return <StyledScrollableWrapper data-scrollable-wrapper="true">{children}</StyledScrollableWrapper>;
};

export default memo(ScrollableTableWrapper);
